import PropTypes from 'prop-types'
import { Button } from '@leroy-merlin-br/backyard-react-ui'

import formatPriceToBRL from 'reactUtils/formatPriceToBRL'

import { dataLayer } from '../services'
import * as S from './styled'

const Discount = ({ discount = 0.0 }) => {
  return (
    <div>
      <S.CartItem>
        <span>Descontos</span>
        <S.DiscountInputWrapper>
          <span>-{formatPriceToBRL(discount)}</span>
        </S.DiscountInputWrapper>
      </S.CartItem>
    </div>
  )
}

const FreightText = ({ freight = 0.0 }) => {
  if (freight === 0) {
    return <S.DiscountInputWrapper>
      <span>Grátis</span>
    </S.DiscountInputWrapper>
  }

  return <span className="bold">{formatPriceToBRL(freight)}</span>
}

const Summary = ({
  cart,
  services,
  context,
  discount,
  canBePurchased,
  subtotal,
  servicesSubTotal,
  total,
  freight,
  regionId
}) => (
  <S.SummaryWrapper context={context}>
    <S.CartInfo context={context}>
      <S.CartItem>
        <span>Subtotal</span>
        <span className="bold">{formatPriceToBRL(subtotal)}</span>
      </S.CartItem>
      {
        freight !== null && <S.CartItem>
          <span>Frete estimado</span>
          <FreightText freight={freight} />
        </S.CartItem>
      }
      { discount > 0 && <Discount discount={discount} />}
      {
        servicesSubTotal > 0 && <S.CartItem>
          <span>Serviço de Instalação</span>
          <span className="bold">{formatPriceToBRL(servicesSubTotal)}</span>
        </S.CartItem>
      }
      <S.Footer>
        <strong>Total estimado</strong>
        <strong>{formatPriceToBRL(total)}</strong>
      </S.Footer>
    </S.CartInfo>

    <S.ButtonWrapper>
      <Button
        data-cy="proceed-to-address-button"
        onClick={() => dataLayer.cartCheckout(cart, regionId, services)}
        href="/pedido/entrega"
        isDisabled={!canBePurchased}
        isStretch
      >
        Continuar para pagamento
      </Button>
    </S.ButtonWrapper>
  </S.SummaryWrapper>
)

Summary.propTypes = {
  context: PropTypes.array.isRequired,
  discount: PropTypes.number,
  canBePurchased: PropTypes.bool,
  subtotal: PropTypes.number.isRequired,
  total: PropTypes.number.isRequired
}

export default Summary
